/* global branch */
import getQueryParams from './getQueryParams';
import { getEventThumbnail } from './Thumbnails';
import store from '../store';
import helper from './helper';

const getAction = type => {
    switch(type) {
        case 'clip':
            return 'clipSharing';
        case 'hd':
            return 'eventHdSharing';
        case 'autohighlight':
            return 'eventHighlightSharing';
        case 'player-highlight':
            return 'playerHighlightSharing';
    }
};

const getSharedLinkTitle = (currentVideoName, type) => {
    const { name: eventName, startDateTime: eventDate } = store.state.main.video.eventData;
    const eventDataExists = eventName && eventDate;

    switch (type) {
        case 'clip':
            if (eventDataExists) {
                return `You are invited to watch '${eventName}' Highlights`;
            }

            return `You are invited to watch ${currentVideoName}`;
        case 'autohighlight':
        case 'hd':
            if (eventDataExists) {
                return `${eventName}, ${helper.formatDate(eventDate)}, Watch Now!`;
            }

            return `${currentVideoName}, Watch Now!`;
        case 'player-highlight':
            if (eventDataExists) {
                return `Watch my personal highlight from ${eventName}, ${helper.formatDate(eventDate)}`;
            }

            return `Watch my personal highlight`;
    }
};

const createLink = (linkData) => {
    return new Promise((resolve, reject) => {
        branch.link(linkData, (err, link) => {
            if (!err) {
                resolve(link);
            } else {
                reject(err);
            }
        });
    });
};

const createDeepLink = ({ id, attributes, path, type }) => {
    let itemId = id;
    const { share_id: shareId } = getQueryParams(path);

    if (id.match(/(_hd|_pano)$/)) {
        [itemId] = id.split('_');
    }

    const linkData = {
        data: {
            $canonical_url: path,
            $desktop_url: path,
            $ios_url: path,
            $android_url: path,
            $windows_phone_url: path,
            $blackberry_url: path,
            $fire_url: path,
            $og_image_url: attributes.urls.thumbnail,
            $og_title: getSharedLinkTitle(attributes.name, type),
            token: store.state.main.urlHashData.token,
            itemId
        }
    };

    linkData.data.action = getAction(type);

    if (type === 'hd') {
        if (shareId) {
            linkData.data.shareId = shareId;
            linkData.data.action = 'sharing';
        }

        linkData.data.$og_image_url = getEventThumbnail(itemId, attributes.urls);
    }

    return createLink(linkData);
};

const setJourneyBannersData = (type, url) => {
    branch.setBranchViewData({
        data: {
            action: getAction(type),
            $canonical_url: url
        }
    });
};

export {
    createDeepLink,
    setJourneyBannersData
};
